import { createContext, useContext } from 'react';

export const AnalyticsChatPanelContext = createContext(null);

export const useAnalyticsChatPanel = () => {
    const context = useContext(AnalyticsChatPanelContext);
    if (!context) {
        throw new Error('useAnalyticsChatPanel must be used within AnalyticsChatPanelProvider');
    }
    return context;
};
